import {
  createRouter as createClientRouter,
  createWebHistory,
  RouteRecordRaw,
} from 'vue-router'
import * as NProgress from 'nprogress'

/**
 * routes are generated using vite-plugin-pages
 * each .vue files located in the ./src/pages are registered as a route
 * @see https://github.com/hannoeru/vite-plugin-pages
 */
import routes from 'pages-generated'

/**
 * Here is how a simple route is generated:
 * import { RouteRecordRaw } from 'vue-router'
 *
 * const routes: RouteRecordRaw = [{
 *    component: () => import('/src/pages/wizard-1.vue'),
 *    name: 'wizard-v1',
 *    path: '/wizard-v1',
 *    props: true,
 *    meta: {
 *      requiresAuth: true
 *    },
 * }]
 *
 * Here is how nested routes are generated:
 * import { RouteRecordRaw } from 'vue-router'
 *
 * const routes: RouteRecordRaw = [{
 *    component: () => import('/src/pages/auth.vue'),
 *    path: '/auth',
 *    props: true,
 *    children: [
 *      {
 *        component: () => import('/src/pages/auth/login-1.vue'),
 *        name: 'auth-login-1',
 *        path: 'login-1',
 *        props: true
 *      },
 *    ],
 * }]
 *
 * Uncomment the line below to view the generated routes
 */
// const routes: RouteRecordRaw = [{
//   component: () => import('/src/pages/auth.vue'),
//   path: '/auth',
//   props: true,
// }]
console.log(routes)

export function createRouter() {
  const router = createClientRouter({
    /**
     * If you need to serve vuero under a subdirectory,
     * you have to set the name of the directory in createWebHistory here
     * and update "base" config in vite.config.ts
     */
    // history: createWebHistory('my-subdirectory'),
    history: createWebHistory(),
    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
      // `to` and `from` are both route locations
      // `savedPosition` can be null if there isn't one
      if(to.path !== from.path){
        window.scrollTo(0, 0)
      }
      // return { x: 0, y: 0 }
    },
    routes,
  })

  /**
   * Handle NProgress display on page changes
   */
  router.beforeEach(() => {
    NProgress.start()
  })
  router.afterEach(() => {
    NProgress.done()

    // 移除code
    if (window.location.search.includes('code=')) {
      const urlObj = new URL(window.location.href)
      urlObj.searchParams.delete('code')
      window.history.replaceState({}, '', urlObj.toString())
    }
  })

  return router
}
